import './App.scss';
import {Row, Col, Container} from "react-bootstrap";
import CostCalculator from './components/CostCalculator';
import ContactStrip from './components/ContactStrip';
import Footer from './components/Footer';
import Languages from './components/Languages';
import About from './components/About';
import TopNavbar from "./components/TopNavbar";
import PageBanner from './components/PageBanner';
import Contact from './components/Contact';
import Testimonials from './components/Testimonials';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

//Images & Icons
import bannerImg1 from './assets/images/translation_icon.png';
import bannerImg2 from './assets/images/keyboard_icon.png';
import translation_svg from './assets/images/translation_svg.png';
import translation_svg_hover from './assets/images/translation_svg_hover.png';
import transcript_svg from './assets/images/transcript_svg.png';
import transcript_svg_hover from './assets/images/transcript_svg_hover.png';
import transcreation from './assets/images/transcreation.png';
import transcreationHover from './assets/images/transcreation-hover.png';
import MTPE from './assets/images/MTPE.png';
import MTPEhover from './assets/images/MTPE-hover.png';
import editTextBar from './assets/images/edit-text-bar.png';
import editTextBarHover from './assets/images/edit-text-bar-hover.png';
import review from './assets/images/review.png';
import reviewHover from './assets/images/review-hover.png';

//Client Logos
import microsoft from './assets/images/clients/microsoft.png';
import google from './assets/images/clients/google.png';
import cognizant from './assets/images/clients/cognizant.png';
import accenture from './assets/images/clients/accenture.png';

import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";



const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Home/>
    ),
  },
  {
    path: "languages",
    element: <Languages/>,
  },
  {
    path: "about",
    element: <About/>
  },
  {
    path: "contact",
    element: <Contact/>
  },
  {
    path: "testimonials",
    element: <Testimonials/>
  },
  {
    path: "login",
    element: <Login/>
  },
  {
    path: "dashboard",
    element: <Dashboard/>
  }
]);

const clientsList = [
  {
    id: 1,
    img: microsoft,
    alt: "Microsoft"
  },
  {
    id: 1,
    img: google,
    alt: "Google"
  },
  {
    id: 1,
    img: cognizant,
    alt: "Cognizant"
  },
  {
    id: 1,
    img: accenture,
    alt: "Accenture"
  },
]


function App() {
  return (
    <>
      <div className="zeeepy">
        <TopNavbar/>
        <RouterProvider router={router} />
        <ContactStrip/>
        <Footer/>
        
        
      </div>
    </>
  );
}

export default App;

function Home(){
  return(
    <div className='homepage'>
        <PageBanner 
          msgLine1 ="Fast"
          msgLine2 ="Professional Translation"
          msgLine3 ="Within 24 Hours"
          cta = {true}
          bannerImg1={bannerImg1}
          bannerImg2={bannerImg2}
        />
        
        <div className='count-bar'>
          <Container fluid>
            <Row className=''>
              <Col md={4}>
                <div className='counter'>
                  <h1>120 <sub>+</sub></h1>
                  <p>Languages</p>
                </div>
              </Col>
              <Col md={4}>
                <div className='counter'>
                  <h1>15 <sub>+</sub></h1>
                  <p>Years of Experience</p>
                </div>
              </Col>
              <Col md={4}>
                <div className='counter'>
                  <h1>100 <sub>+</sub></h1>
                  <p>Clients</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className='services' id='services'>
          <h1 className='section-heading'>Services</h1>
          <Container>
            <Row>
              <Col md={4}>
                <div className='service'>
                  <img className='icon' src={translation_svg}></img>
                  <img className='icon-hover' src={translation_svg_hover}></img>
                  <p>Translation Services</p>
                </div>
              </Col>
              <Col md={4}>
                <div className='service'>
                  <img className='icon' src={transcript_svg}></img>
                  <img className='icon-hover' src={transcript_svg_hover}></img>
                  <p>Transcription Services</p>
                </div>
              </Col>
              <Col md={4}>
                <div className='service'>
                  <img className='icon' src={transcreation}></img>
                  <img className='icon-hover' src={transcreationHover}></img>
                  <p>Transcreation Services</p>
                </div>
              </Col>
              {/* Second column */}
              <Col md={4}>
                <div className='service'>
                  <img className='icon' src={MTPE}></img>
                  <img className='icon-hover' src={MTPEhover}></img>
                  <p>MTPE Services</p>
                </div>
              </Col>
              <Col md={4}>
                <div className='service'>
                  <img className='icon' src={editTextBar}></img>
                  <img className='icon-hover' src={editTextBarHover}></img>
                  <p>Post Editing Services</p>
                </div>
              </Col>
              <Col md={4}>
                <div className='service'>
                  <img className='icon' src={review}></img>
                  <img className='icon-hover' src={reviewHover}></img>
                  <p>Review Services</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div id="pricing" className='calculation-and-message'>
          <Container >
            <Row>
              <Col md={7}>
                <h1>
                  Need a professional translation in 24 hours?
                </h1>
                <ul>
                  <li>We offer you fast, reliable, and confidential service.</li>
                  <li>Our certified translators supply official translations of documents for visa, passport and citizenship applications, and all other legal matters.</li>
                  <li>A broad range of other certified translation services for legal, commerce, medical, and technical purposes is also available.</li>
                  <li>You can contact us 24 hours a day, 365 days a year on <b>contact@zeeepy.com</b></li>

                </ul>
              </Col>
              <Col md={5}>
                <CostCalculator/>
              </Col>
            </Row>
          </Container>
          
        </div>

        <div className='clients'>
          <Container>
              <h1 className='section-heading'>Our Clients</h1>
              
              <div className='image-list'>
                <Row>
                  {clientsList.map((item, imgInd)=>{
                    return(
                      <Col key={imgInd}>
                        <div >
                          <img src={item.img} key={imgInd} alt={item.alt}/>
                        </div>
                      </Col>
                    )
                  })}
                    
                </Row>
              </div>
              
          </Container>
       </div>
        
    </div>
  )
  
}

